var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBookingNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48975 12.3521H8.23467V15.097H5.48975V12.3521ZM5.48975 17.8419H8.23467V20.5868H5.48975V17.8419ZM10.9796 12.3521H13.7245V15.097H10.9796V12.3521ZM10.9796 17.8419H13.7245V20.5868H10.9796V17.8419ZM16.4695 12.3521H19.2144V15.097H16.4695V12.3521ZM16.4695 17.8419H19.2144V20.5868H16.4695V17.8419Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74493 27.4493H21.9594C23.4732 27.4493 24.7043 26.2182 24.7043 24.7043V5.48986C24.7043 3.97603 23.4732 2.74493 21.9594 2.74493H19.2145V0H16.4696V2.74493H8.23478V0H5.48985V2.74493H2.74493C1.2311 2.74493 0 3.97603 0 5.48986V24.7043C0 26.2182 1.2311 27.4493 2.74493 27.4493ZM21.9594 8.23478L21.9608 24.7043H2.74493V8.23478H21.9594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBookingNavIcon);
export default __webpack_public_path__ + "static/media/my_booking_nav_icon.545559e9b82a426d9dd8177b1a4f9297.svg";
export { ForwardRef as ReactComponent };